/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import {
  cellRenderer,
  cellRendererFourDec,
} from '../../../../SharedModules/utilities/utilities';

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount1 && amount1?.toString()?.includes('%')) {
    amt1 = parseFloat(
      amount1?.toString().split('%')[0]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('%')) {
    amt2 = parseFloat(
      amount2?.toString().split('%')[0]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}

const comparatorQtr = (a, b) => {
  // Ensure both `a` and `b` are strings; if not, set them to empty strings
  const strA = a && typeof a === 'string' ? a : '';
  const strB = b && typeof b === 'string' ? b : '';

  // Split both strings by 'Q'
  const splittedQtrA = strA.split('Q');
  const splittedQtrB = strB.split('Q');

  // Default values in case of unexpected formats
  const qtrNumberA = splittedQtrA[1] ? parseInt(splittedQtrA[1], 10) : 0;
  const qtrNumberB = splittedQtrB[1] ? parseInt(splittedQtrB[1], 10) : 0;
  const yearA = splittedQtrA[0] ? parseInt(splittedQtrA[0], 10) : 0;
  const yearB = splittedQtrB[0] ? parseInt(splittedQtrB[0], 10) : 0;

  // Compare quarters and years
  return qtrNumberA - qtrNumberB || yearA - yearB;
};

// grid on first Screen
export const manufacturersTableGrid = [
  {
    headerName: 'Select',
     minWidth: Styles.Width_50,
    filter: false,
    checkboxSelection: true, // For rows checkbox
    headerCheckboxSelection: false, // For header check box
    field: 'checkSelect',
    editable: false,
    suppressMenu: false,
    sortable: false,
    maxWidth: 135,
    cellStyle: { borderRightColor: Styles.BorderColor },
    pdfExportOptions: {
      skipColumn: true,
    },
   },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const detailReportTypeTableGrid = [
  {
    headerName: 'Action',
    field: 'action',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    wrapText: true,
    minWidth: Styles.Width_100,
    cellRenderer: 'ActionCellRender',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: false,
    pdfExportOptions: {
      skipColumn: true,
    },
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    resizable: true,
    wrapText: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drug_name',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    wrapText: true,
    columnSpan: 3,
    minWidth: Styles.Width_240,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Qtr',
    field: 'paid_qtr',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    comparator: comparatorQtr,
    resizable: true,
    wrapText: true,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'HCPCS Code',
    field: 'jcode',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    wrapText: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'URA',
    field: 'ura',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    wrapText: true,
    cellRenderer: cellRendererFourDec,
    comparator: amountComparator,
    excelAlignment: 'right',
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    // printPrefixValue: '$',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Medical Claim Units',
    field: 'jcode_units',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    excelAlignment: 'right',
    comparator: amountComparator,
    cellRenderer: 'TotalUnitsCellRender',
    displayTextOnly: 'Grand Total:',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportZeroesFour: true,
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Percent Medical',
    field: 'percent_medical',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    resizable: true,
    alignment: 'right',
    exportZeroesTwo: true,
    excelAlignment: 'right',
    isTextColorRed: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    printPostfixValue: '%',
    comparator: amountComparator,
    cellRenderer,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Reimbursed Amt',
    field: 'jcodereimb_amt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    printPrefixValue: '$',
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'Invoiced Amt',
    field: 'inv_amt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    isAmount: true,
    minWidth: Styles.Width_150,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    printPrefixValue: '$',
    exportZeroesTwo: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Paid Amt',
    field: 'total_paid_amt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    isAmount: true,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    // valueFormatter: dollarFormatter,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    printPrefixValue: '$',
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
];

export const summaryReportTypeTableGrid = [
  {
    headerName: 'MFG ID',
    field: 'labeler_code',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'MFG Name',
    field: 'labeler_name',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    wrapText: true,
    minWidth: Styles.Width_230,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'QTR',
    field: 'qtr',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    comparator: comparatorQtr,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Reimbursed Amt',
    field: 'jcodereimb_amt',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    printPrefixValue: '$',
    exportZeroesTwo: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Invoiced Amt',
    field: 'inv_amt',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    printPrefixValue: '$',
    exportZeroesTwo: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Paid Amt',
    field: 'paid_amt',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    printPrefixValue: '$',
    exportZeroesTwo: true,
    minWidth: Styles.Width_138,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
];

export const summaryReportTypeTableGridWithOutQtr = [
  {
    headerName: 'MFG ID',
    field: 'labeler_code',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'MFG Name',
    field: 'labeler_name',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    wrapText: true,
    minWidth: Styles.Width_230,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Reimbursed Amt',
    field: 'jcodereimb_amt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    printPrefixValue: '$',
    exportZeroesTwo: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Invoiced Amt',
    field: 'inv_amt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    printPrefixValue: '$',
    exportZeroesTwo: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Paid Amt',
    field: 'paid_amt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    printPrefixValue: '$',
    exportZeroesTwo: true,
    minWidth: Styles.Width_138,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
];

export const getRequiredColumnOnExportPDF = (name, columnApi) => {
  const colDisplayArray = columnApi.getAllDisplayedColumns()?.map((prop) => {
    return { ...prop, ...prop.colDef };
  });
  return colDisplayArray.filter((item) => {
    return (
      !item?.colDef?.removeColumn && !item?.colDef?.pdfExportOptions?.skipColumn
    );
  });
};
